import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/tel/verify",
    name: "index",
  },
  {
    path: "/tel/verify",
    name: "verifyIdentity",
    component: () =>
      import(/* webpackChunkName: "verifyIdentity" */ "@/views/HomeView.vue"),
  },
  {
    path: "/tel/bindData",
    name: "bindData",
    component: () =>
      import(/* webpackChunkName: "bindData" */ "@/views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_API),
  routes,
});

export default router;
